import React from 'react';
import { CheckIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { company, included, offer } from '../../data/offer';
import { Section } from './Section';
export function Investment() {
  return <Section index="07" label="Investering" title="Vaste prijs" intro="50% bij akkoord, 50% bij livegang. Optioneel hosting en onderhoud: € 49 per maand." data-id="element-12" data-mp="n7wfqj8rrh2v">
      <div className="grid gap-10 rounded-xl border border-line bg-surface p-8 md:grid-cols-2 md:p-10" data-id="element-13" data-mp="da8agzdjer6g">
        <div data-id="element-14" data-mp="8j9njgy1muu8">
          <p className="whitespace-nowrap text-5xl font-semibold tracking-tight text-white md:text-7xl" data-id="element-15" data-mp="8iqih0ths0xm">
            {offer.price}
          </p>
          <p className="mt-3 text-sm text-white/45" data-id="element-16" data-mp="3im2dbwhx87x">{offer.priceNote}</p>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-17" data-mp="3vq2bv4ldyqtt">
            <a href={`mailto:${company.email}?subject=Akkoord%20offerte%20${encodeURIComponent(offer.subject)}`} className="inline-flex items-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-accent-dark" data-id="element-18" data-mp="3qp4ugu87a0td">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-19" data-mp="1phlgh22ru25t" />
              Akkoord geven
            </a>
            <a href={`tel:${company.phoneHref}`} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-line px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30 hover:bg-white/5" data-id="element-20" data-mp="1bqgcjnsdenpo">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="28ew3nob4p54w" />
              {company.phone}
            </a>
          </div>
        </div>

        <div className="border-t border-line pt-8 md:border-l md:border-t-0 md:pl-10 md:pt-0" data-id="element-22" data-mp="1zer94er1a185">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-23" data-mp="1zgke7pm00de1">
            Inbegrepen
          </p>
          <ul className="mt-5 space-y-3.5" data-id="element-24" data-mp="o03yrwag1wr6">
            {included.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-white/80" data-id="element-25" data-mp="3x83hx7auutp">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-26" data-mp="3w1inwank9bjv" />
                <span data-id="element-27" data-mp="3rak4h279zxce">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}